import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import authReducer from '@store/authSlice';
import profileReducer from '@store/profileSlice';
// Master Data Slices
import vesselReducer from '@store/masterData/vesselSlice';
import portReducer from '@store/masterData/portSlice';
import productReducer from '@store/masterData/productSlice';
import productSpeciesReducer from '@store/masterData/productSpeciesSlice';
import productQualityReducer from '@store/masterData/productQualitySlice';
import productSizeReducer from '@store/masterData/productSizeSlice';
import productStateReducer from '@store/masterData/productStateSlice';
import positionReducer from '@store/masterData/positionSlice';
import workerReducer from '@store/masterData/workerSlice';
import ledgerCategoryReducer from '@store/masterData/ledgerCategorySlice';
// Contract Slices
import contractReducer from '@store/contract/contractSlice';
import contractCatchPriceListReducer from '@store/contract/contractCatchPriceListSlice';
import contractRateReducer from '@store/contract/contractRateSlice';
import contractShareReducer from '@store/contract/contractShareSlice';
import contractCostReducer from '@store/contract/contractCostSlice';
import contractWorkByReducer from '@store/contract/contractWorkBySlice';
import contractCePointsReducer from '@store/contract/contractCePointsSlice';
import contractCeRatesReducer from '@store/contract/contractCeRatesSlice';
// Fishing Trip Slices
import fishingTripReducer from '@store/fishingTrip/fishingTripSlice';
import tripPeriodReducer from '@store/fishingTrip/tripPeriodSlice';
import tripCatchReducer from '@store/fishingTrip/tripCatchSlice';
import tripCrewReducer from '@store/fishingTrip/tripCrewSlice';
import tripCostReducer from '@store/fishingTrip/tripCostSlice';
// Work By Hours Slices
import workByHoursReducer from '@store/workByHours/workByHoursSlice';
import workByRecordReducer from '@store/workByHours/workByRecordSlice';
// Bonuses
import cePointsReducer from '@store/fishingTrip/cePointsSlice';
import tripExtraReducer from '@store/fishingTrip/tripExtraSlice';
// Rules
import interimPayReducer from '@store/fishingTrip/rules/interimPaySlice';
import endOfTripReducer from '@store/fishingTrip/rules/endOfTripSlice';
import washupReducer from '@store/fishingTrip/rules/washupSlice';
import extrasReducer from '@store/fishingTrip/rules/extrasSlice';
//
import ledgerReducer from '@store/calculations/ledgerSlice';
import reportReducer from '@store/calculations/reportSlice';

const rootPersistConfig = {
  key: 'root',
  version: 1,
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  vessel: vesselReducer,
  port: portReducer,
  product: productReducer,
  productSpecies: productSpeciesReducer,
  productQuality: productQualityReducer,
  productSize: productSizeReducer,
  productState: productStateReducer,
  position: positionReducer,
  worker: workerReducer,
  workByHours: workByHoursReducer,
  workByRecord: workByRecordReducer,
  contract: contractReducer,
  contractCatchPriceList: contractCatchPriceListReducer,
  contractRate: contractRateReducer,
  contractShare: contractShareReducer,
  contractCost: contractCostReducer,
  contractWorkBy: contractWorkByReducer,
  contractCePoints: contractCePointsReducer,
  contractCeRates: contractCeRatesReducer,
  fishingTrip: fishingTripReducer,
  tripPeriod: tripPeriodReducer,
  tripCatch: tripCatchReducer,
  tripCrew: tripCrewReducer,
  tripCost: tripCostReducer,
  ledger: ledgerReducer,
  ledgerCategory: ledgerCategoryReducer,
  report: reportReducer,
  interimPay: interimPayReducer,
  endOfTrip: endOfTripReducer,
  washup: washupReducer,
  cePoints: cePointsReducer,
  tripExtra: tripExtraReducer,
  extras: extrasReducer,
});

export { rootPersistConfig, rootReducer };
